<!-- 
	Badge
	props: User
  	role: User
	Called by @/views/User && @/views/Settings to display a fancy badge of user information
	This component is disabled on Mobile on the settings page
-->

<template>
	<div class="badge">
		<div class="top mx-auto d-flex flex-column">
			<div class="text mx-auto" style="max-width: 200px; text=align:center">

				<p class="smaller">You are currently</p>
				<p class="amount py-4" style="white-space: normal">{{isCurrentlyEnrolled ? "ENROLLED" : "NOT ENROLLED"}}
				</p>
				<p class="smaller">In the 2025 WinWin Staff Lottery</p>
				<!-- <div v-else>
					<div>
						<span class="amount">No</span><br />
						<span class="smaller">Main Ticket Package</span><br />
						<span>Selected</span>
					</div>
				</div> -->
				<!--
				<template v-if="!isCurrentlyEnrolled">
					<div class="text-sm" v-if="!isCurrentlyEnrolled">Next deadline date</div>
					<p class="text-sm font-bold">{{nextDeadlineDate}}</p>
				</template>
				-->
			</div>
		</div>
		<div class="middle mx-auto">
			<div class="name">
				{{ user.apiData.Profile.FirstName }} {{ user.apiData.Profile.LastName }}
			</div>
			<div class="email">
				{{ user.apiData.Profile.EmailAddress }}
			</div>
		</div>
		<div class="bottom mx-auto">
			<div class="benefitting">
				<p>{{
					user.apiData.Profile.NewDesignation ||
						user.apiData.Profile.CurrentDesignation
				}}</p>
			</div>
			<div class="employeeId">
				Employee ID {{ user.apiData.Profile.EmployeeId }}
			</div>
			<hr />
			<div class="company">
				<span v-if="user.apiData.Profile.PayrollSelection === 'CHR'">
					Alberta Health Services
				</span>
				<span v-if="user.apiData.Profile.PayrollSelection === 'CW'">
					Carewest
				</span>
				<span v-if="user.apiData.Profile.PayrollSelection === 'COV'">
					Covenant Health
				</span>
				<span v-if="user.apiData.Profile.PayrollSelection === 'LAB'">
					Alberta Precision Labs
				</span>
			</div>

			<!--
			<a href="/user">
          	<button
            class="mx-auto rounded-lg my-4 py-2 px-4 bg-gray-500 text-gray-100 hover:bg-gray-800 duration-300 text-base"
          	>
            VIEW MY PROFILE
          	</button>
        	</a>
			-->
		</div>
	</div>
</template>
<script>
import {nextDeadlineDate, nextDrawDateWhenEnrolled} from '@/utils/constants'
	export default {
		name: "Badge",
		props: ["user"],
		computed: {
			nextDeadlineDate: () => nextDeadlineDate(new Date()),
			nextDrawDate: () => nextDrawDateWhenEnrolled(new Date()),
			// isCurrentlyEnrolled: function() {
			// 	return this.user?.apiData?.Profile?.CurrentMainTicketPackage !== null ||
			// 				this.user?.apiData?.Profile?.NewMainTicketPackage !== null ||
			// 				this.user?.apiData?.Profile?.Current5050TicketPackage !== null ||
			// 				this.user?.apiData?.Profile?.New5050TicketPackage !== null ||
			// 				this.user?.apiData?.Profile?.Year2022
			// }
						isCurrentlyEnrolled: function() {
							return this.user?.apiData?.Profile?.Year2025 && !this.user?.apiData?.Profile?.OptOutMain && !this.user?.apiData?.Profile?.OptOut5050
			}
		}
	};
</script>
<style lang="scss" scoped>
	.badge {
		margin: 0 auto;
		text-align: center;
		.top {
			background: url("../assets/badge-package.svg") top center/cover no-repeat;
			width: 295px;
			min-height: 249px;
			color: #ffffff;
			.text {
				padding-top: 6rem;
				font-size: 30px;
				line-height: 1;
				.amount {
					text-transform: uppercase;
					padding-top: 15px;
				}
				.smaller {
					font-size: 15px;
				}
				.dollars {
					font-size: 72px;
					vertical-align: middle;
				}
			}
		}
		.middle {
			background: url("../assets/badge-name-email.svg") top center/cover
				no-repeat;
			width: 295px;
			color: black;
			padding: 1rem 0;
			.name {
				text-transform: uppercase;
				font-size: 24px;
			}
			.email {
				text-transform: lowercase;
				font-size: 15px;
			}
		}
		.bottom {
			background: url("../assets/badge-facility-id-payroll.svg") top
				center/cover no-repeat;
			color: #e5d876;
			width: 295px;
			padding: 1rem 0;
			.benefitting {
				padding: 15px 0 30px;
				font-size: 18px;
				white-space: normal;
			}
			.employeeId {
				padding: 7rem 0 0;
				text-transform: uppercase;
				color: #ffffff;
			}
			hr {
				width: 60%;
				margin: 5px auto;
				border-color: #b4816d;
			}
			.company {
				text-transform: uppercase;
				color: #ffffff;
			}
		}
	}
</style>
